import mirrorCreator from 'mirror-creator';

const actionTypes = mirrorCreator([
  'CLEAR_API_STATE',
  'SELECT_ENTITY',
  'LAST_SELECTED_ENTITY',
  'LAST_CREATED_ENTITY',
  'CLEAR_LAST_SELECTED_ENTITY',
  'SET_ACTIVE_PAGE',
  'SET_ACTIVE_FILTERS',
  'SET_ACTIVE_SORT',
  'SET_ACTIVE_SEARCH',
  'SET_ACTIVE_STATE',
  'RESET_ACTIVE_PROPS',
  'SET_CURRENT_ENTITY_VALUES',
  'CREATE_CURRENT_ENTITY',
  'START_DOWNLOAD',
  'DOWNLOAD_SUCCESS',
  'DOWNLOAD_FAIL',
  'REPORT_TIMEOUT',
  'END_TIMEOUT',
  'DISPLAY_ERROR',
  'DELETE_ENTITY',
  'DISPLAY_SUCCESS',
  'CLEAR_MESSAGES',
  'DISPLAY_ERRORS',
  'ENTITY_WILL_READ'
]);

export default actionTypes;
